<router-outlet></router-outlet>
<app-app-loader *ngIf="isLoading"></app-app-loader>
